import React,{useEffect} from 'react'
import { useLocation } from 'react-router-dom'
import './Industry_Focus.css'
// import industry1 from '../../assets/images/industry1.png'
import industry2 from '../../assets/images/industry2.png'
import industry3 from '../../assets/images/industry3.png'
import industry4 from '../../assets/images/industry4.png'
import banner from '../../assets/images/industry banner.png'
import aos from 'aos';
import 'aos/dist/aos.css'


const Industry_Focus = () => {
  const { top } = useLocation();
  useEffect(() => {
    aos.init({ duration: 1000 });
    window.scrollTo(0,0);
  }, [top]);
  return (
    <div>
      <div className="container-fluid gx-0">
        <div className="row gx-0">
          <img className='img-fluid' data-aos="zoom-in" src={banner} alt="" />
        </div>
      </div>
       <div className="container py-lg-5">
        
      <div className="row mb-3">
        <p className='text-center px-lg-5 top-content' data-aos="zoom-in" >The pharmaceutical industry is rapidly evolving, driven by innovative therapies, cutting-edge technologies, and unmet medical needs. Here are the key areas where the global and Indian pharmaceutical industry is focusing.</p>
      </div>
      
      {/* <div className="row py-lg-5 py-3 change-column-direction">
        <div className="col-lg-6 col-md-6 d-flex align-items-center" data-aos="zoom-in">
          <div className="content industry-content">
            <h4><label></label> Global Focus Areas <label></label></h4>
            <p>1. Oncology: Targeted therapies, immunotherapy, and precision medicine.</p>
            <p>2. Rare Diseases: Orphan drugs, gene therapies, and personalized medicine.</p>
            <p>3. Infectious Diseases: Antimicrobial resistance, COVID-19 vaccines, and pandemic preparedness.</p>
            <p>4. Neurosciences: Alzheimer's, Parkinson's, and mental health treatments.</p>
            <p>5. Gene Editing: CRISPR, CAR-T cell therapy, and regenerative medicine.</p>
          </div>
        </div>
        <div className="col-lg-6 col-md-6">
          <img className='img-fluid' data-aos="zoom-in" src={industry1} alt="" />
        </div>
      </div> */}

      <div className="row py-lg-5 py-3">
      <div className="col-lg-6 col-md-6">
          <img className='img-fluid' data-aos="zoom-in" src={industry2} alt="" />
        </div>
        <div className="col-lg-6 col-md-6 d-flex align-items-center">
          <div className="content industry-content" data-aos="zoom-in">
            <h4><label></label> Indian Pharmaceutical Industry Focus <label></label></h4>
            <p>1. Affordable Healthcare: Generic and biosimilar medicines for emerging markets.</p>
            <p>2. Chronic Disease Management: Diabetes, cardiovascular, and respiratory care.</p>
            <p>3. Vaccine Development: Indigenous vaccine production for infectious diseases.</p>
            <p>4. Ayurveda and Herbal Research: Integrating traditional medicine with modern science.</p>
            <p>5. Digital Health: Telemedicine, health analytics, and AI-powered diagnostics.</p>
          </div>
        </div>
        
      </div>

      <div className="row py-lg-5 py-3 change-column-direction">
        <div className="col-lg-6 col-md-6 d-flex align-items-center">
          <div className="content industry-content" data-aos="zoom-in">
            <h4><label></label> Pipeline Therapy Areas <label></label></h4>
            <p>1. Cell and Gene Therapies: CAR-T, stem cell, and gene editing treatments.</p>
            <p>2. Biologics and Biosimilars: Monoclonal antibodies, vaccines, and bio-betters.</p>
            <p>3. Precision Medicine: Targeted therapies, companion diagnostics, and biomarkers.</p>
            <p>4. Immunotherapies: Cancer, autoimmune, and infectious disease treatments.</p>
            <p>5. 3D Printing and Nanotechnology: Personalized medicine and targeted delivery.</p>
          </div>
        </div>
        <div className="col-lg-6 col-md-6">
          <img className='img-fluid' data-aos="zoom-in" src={industry3} alt="" />
        </div>
      </div>

      <div className="row py-lg-5 py-3">
      <div className="col-lg-6 col-md-6">
          <img className='img-fluid' data-aos="zoom-in" src={industry4} alt="" />
        </div>
        <div className="col-lg-6 col-md-6 d-flex align-items-center">
          <div className="content industry-content" data-aos="zoom-in">
            <h4><label></label> Emerging Trends <label></label></h4>
            <p>1. Artificial Intelligence (AI): Drug discovery, clinical trials, and patient engagement.</p>
            <p>2. Internet of Medical Things (IoMT): Wearables, telehealth, and remote monitoring.</p>
            <p>3. Blockchain: Supply chain management, counterfeiting prevention, and data security.</p>

          </div>
        </div>
        
      </div>

      

    </div>
    </div>
  )
}

export default Industry_Focus
